import React, { useEffect, useState } from 'react';
import './assets/css/bootstrap.min.css';
import './assets/css/accordion.css';
import './assets/css/slick.css';

import {
  Disclaimer,
  Form,
  MainPage,
  PageTitle,
  ThankYou,
  ThankYouLenderList,
  TopBarAndFooter,
} from './components';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useTrustedForm, useJornaya, useAnura, useExternalScript } from './lib/hooks';
import { Helmet } from 'react-helmet-async';
import FormEmbedded from "./components/Form/FormEmbedded";

const App = () => {
  useTrustedForm();
  useJornaya();
  useAnura();
  useExternalScript(
      'https://rgr-js.s3.us-west-2.amazonaws.com/tracking.js',
      'tracking_env',
      process.env.REACT_APP_ENV
  );

    const [isFramed, setIsFramed] = useState(false);

    useEffect(() => {
        setIsFramed(window.self !== window.top);
    }, []);

  return (
      <div className="page">
        <PageTitle title={process.env.REACT_APP_TAB_NAME}/>
        <Helmet>
        <script type="text/javascript">
          {`var pixelrgr_type = 'homeseller';
                      var pixelrgr_source = '${process.env.REACT_APP_SOURCE}';
                      var pixelrgr_url = "${process.env.REACT_APP_API_URL}";`}
        </script>
        <script src="https://rgr-js.s3.us-west-2.amazonaws.com/pixel.js" type="text/javascript"></script>
        </Helmet>
        <Router>
          <Routes>
            <Route
                path="/"
                element={
                  <>
                    <TopBarAndFooter/>
                    <MainPage/>
                    <div>
                      <div className="disclaimer">
                        <Disclaimer/>
                      </div>
                    </div>
                  </>
                }
            />
            <Route
                path="/form/:step?"
                element={
                  <>
                    <TopBarAndFooter/>
                    <Form/>
                    <div>
                      <div className="disclaimer">
                        <Disclaimer/>
                      </div>
                    </div>
                  </>
                }
            />
            <Route
                path="/embedded"
                element={
                    <>
                        <FormEmbedded/>
                    </>
                }
            />
            <Route
                path="/thank-you"
                element={
                  <>
                      {!isFramed &&
                          <TopBarAndFooter page="thankyou"/>
                      }
                      <ThankYou/>
                      {!isFramed &&
                        <div>
                          <div className="disclaimer">
                            <Disclaimer/>
                          </div>
                        </div>
                      }
                  </>
                }
            />
            <Route
              path="/thank-you-lender-list"
              element={
                <>
                    {!isFramed &&
                      <TopBarAndFooter page="thankyou"/>
                    }
                    <ThankYouLenderList/>
                    {!isFramed &&
                      <div>
                        <div className="disclaimer">
                          <Disclaimer/>
                        </div>
                      </div>
                    }
                </>
              }
            />
          </Routes>
        </Router>
      </div>
  );
};

export default App;
